<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
<div class="md-grey-page center-horizontal">
	<div class="page-banner"></div>
    <section class="settings container-white">

        <div class="settings-header">
            <h2>Welcome to BestAgent <br />{{fullname}}</h2>
				<div v-if="demoMode">
					<h4>There are just 3 easy steps to getting your account fully live and uploading to portals.</h4>
					<ol>
						<li>(Optional) Practice adding dummy properties in Demo mode to get used to it</li>
						<li>Activate “Live mode” and add all your live properties</li>
						<li>Activate your real-time Rightmove and Zoopla uploads and any other portal feeds you want</li>
					</ol>
					<p>You will then be able to activate your new free website and, or your GDPR-compliant applicant database function.</p>
					<h3>Ready to get started?</h3>
					<div class="settings-buttons__section">
	  		  			<button class="mdc-button mdc-button--raised" @click="$router.push('/properties/add')">Add a practice property</button>
	  		  	 	</div>
					<p>Just so you know, any practice properties you add in Demo mode will be deleted when you switch to Live mode.</p>
				</div>

				<div v-if="!demoMode">
				  <p>First you should add your live properties, once you've done that you can activate your portals.</p>
				</div>
        </div>

        <div class="settings-buttons" v-if="!demoMode">
            <div class="settings-buttons__section">
                <div class="">
	                <button class="mdc-button mdc-button--raised" @click="$router.push('/properties/add')">Add Property</button>
				 	 </div>
                <!-- <div class="">
                   <button class="mdc-button mdc-button--raised" v-on:click="$router.push('/applicants/add')">Add Applicant</button>
					 </div> -->
					 <div class="">
					 	 <button class="mdc-button mdc-button--raised" @click="$router.push('/settings/portals')" :disabled="demoMode">Launch Portal Upload(s) <span v-if="demoMode">(only on Live Mode)</span></button>
					 </div>
					 <div class="" v-if="demoMode">
					 	 <button class="mdc-button mdc-button--raised" @click="$router.push('/settings/demo-mode')">Activate Live Mode now</button>
					 </div>
					 <div v-if="!websiteActive">
						 <button class="mdc-button mdc-button--raised" @click="$router.push('/settings/website-setup')" :disabled="demoMode">
	                  Create my Website <span v-if="demoMode">(only on Live Mode)</span>
	                </button>
					 </div>
					 <div v-else>
						<button class="mdc-button mdc-button--raised" @click="$router.push('/settings/website')" :disabled="demoMode">
							Website Settings <span v-if="demoMode">(only on Live Mode)</span>
						</button>
					</div>
            </div>
        </div>

    </section>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
export default {
	data: function() {
		return {
			websiteActive: false
		}
	},
	created: async function() {
		const website = await api({endpoint: this.config.services.website, path: '/get-site', method: 'GET'});
		if(website.response.Item){
			this.websiteActive = true;
		}
	},
	computed: {
	  demoMode: function() {
		  return this.$store.getters.demoMode;
	  },
	  fullname: function() {
		  return this.$store.getters.fullname;
	  }
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Start.vue